import type { StyleProps, SystemStyleObject } from "@ui/types";

export const styles = {
    fieldStyle: {
        px: 0,
        py: 1,
        fontSize: "mobileH1",
        fontWeight: "bold",
        bg: "black !important",
        color: "white",
        borderColor: "white",
        _hover: {
            borderColor: "white",
        },
        _focusVisible: {
            borderColor: "unset",
        },
    },
    wrapper: {
        w: ["full", "45%"],
        flexDir: "column",
        mb: 6,
    },
    inputsWrapper: {
        flexDir: "column",
        mb: 5,
    },
    fieldErrorStyle: {
        borderBottom: "3.4px solid errorOnBlack !important",
        color: "errorOnBlack",
        _hover: {
            borderColor: "error",
        },
    },
    button: {
        bg: "black !important",
        color: "white",
    },
    label: {
        color: "white",
    },
    formErrorMessage: {
        color: "errorOnBlack",
    },
} satisfies Record<string, StyleProps | SystemStyleObject>;
